const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_ApprovalToMe":
      return { ...state, ToMe: payload };
    case "SAVE_ApprovalByMe":
      return { ...state, ByMe: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
